import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-windows-sql-cloud',
  templateUrl: './windows-sql-cloud.component.html',
  styleUrls: ['./windows-sql-cloud.component.css']
})
export class WindowsSqlCloudComponent implements OnInit {

  // Calculator Properties
  selectedCores = 4;
  selectedRam = 16;
  selectedStorage = 500;
  selectedEdition = 'standard';
  
  estimatedPrice = 0;

  // Options
  editionOptions = [
    { id: 'web', name: 'Web Edition', priceMultiplier: 0.5 },
    { id: 'standard', name: 'Standard Edition', priceMultiplier: 1.0 },
    { id: 'enterprise', name: 'Enterprise Edition', priceMultiplier: 2.5 }
  ];

  // FAQ Data
  faqs = [
    {
      question: 'What versions of SQL Server are supported?',
      answer: 'We support SQL Server 2016, 2017, 2019, and 2022. You can choose your preferred version during deployment.',
      isOpen: false
    },
    {
      question: 'How is licensing handled?',
      answer: 'All our Windows SQL Cloud instances include the license cost in the monthly fee. You can also bring your own license (BYOL) with Software Assurance.',
      isOpen: false
    },
    {
      question: 'Can I scale my resources later?',
      answer: 'Yes, you can scale CPU and RAM vertically with minimal downtime. Storage can be expanded online without any downtime.',
      isOpen: false
    },
    {
      question: 'Do you provide backups?',
      answer: 'Yes, automated daily backups are included by default with 7-day retention. You can configure custom backup schedules and retention policies.',
      isOpen: false
    }
  ];

  constructor() { }

  ngOnInit(): void {
    this.calculatePrice();
  }

  calculatePrice() {
    // Base infrastructure cost
    const cpuCost = this.selectedCores * 15; // $15 per core
    const ramCost = this.selectedRam * 4;    // $4 per GB RAM
    const storageCost = this.selectedStorage * 0.10; // $0.10 per GB SSD

    // License cost
    const edition = this.editionOptions.find(e => e.id === this.selectedEdition);
    const licenseCost = (cpuCost * (edition?.priceMultiplier || 1)) * 0.5; // Simplified license model

    this.estimatedPrice = cpuCost + ramCost + storageCost + licenseCost;
  }

  toggleFaq(index: number) {
    this.faqs[index].isOpen = !this.faqs[index].isOpen;
  }

  updateCores(event: any) {
    this.selectedCores = parseInt(event.target.value);
    this.calculatePrice();
  }

  updateRam(event: any) {
    this.selectedRam = parseInt(event.target.value);
    this.calculatePrice();
  }

  updateStorage(event: any) {
    this.selectedStorage = parseInt(event.target.value);
    this.calculatePrice();
  }

  setEdition(editionId: string) {
    this.selectedEdition = editionId;
    this.calculatePrice();
  }
}
